import TableCustomized from "../../../common/components/TableCustomized";
import PaperCustomized from "../../../common/components/PaperCustomized";
import { formattedDateFromDB } from "../../../common/utils/FunctionsUtils";

function ListMarchandisesImputees(props) {
  const columns = [
    {
      field: "dateImp",
      headerName: "Date d'imputation",
      flex: 0.7,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "montant",
      headerName: "Montant imputé",
      flex: 0.7,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "qte",
      headerName: "Quantité",
      flex: 0.7,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "devise",
      headerName: "Devise",
      flex: 0.9,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "dum",
      headerName: "DUM",
      flex: 0.7,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "observation",
      headerName: "Observation",
      flex: 0.7,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "version",
      headerName: "Version",
      flex: 0.7,
      hideable: false,
      sortable: false,
      headerClassName: "super-app-theme--header",
    },
  ];
  const rows = [];
  props?.detail?.marchandisesImputes?.map((row, index) => {
    rows.push({
      id: row.id,
      dateImp: formattedDateFromDB(row.dateImputation),
      montant: row.quantiteImpute,
      qte: row.quantite,
      devise: row.devise?.description,
      dum: row.dum?.numDum,
      observation: Boolean(row.enviada) ? "Envoyée" : "Non encore envoyée",
      version: Boolean(row.version) ? "Nouvelle" : "Ancienne",
    });
  });
  return (
    <PaperCustomized title={"Marchandises imputées"} forActions={false}>
      <TableCustomized
        columns={columns}
        rows={rows}
        totalElements={rows.length}
        pageSizeOptions={[10, 25, 50, 100]}
        paginationMode="client"
        isSlots={false}
        isFooter={true}
        noDataHeight="120px"
        cursor="auto"
      />
    </PaperCustomized>
  );
}

export default ListMarchandisesImputees;
